export default __webpack_public_path__ + "static/assets/med_pill_round_out_L0_solid_m_01_f_mask.1b550394.png";